import React, { Component } from 'react';
import {Badge, Button, Overlay, OverlayTrigger, Tooltip} from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {faUserCheck, faUserTie, faUserXmark, faWarning} from '@fortawesome/free-solid-svg-icons';

class SupervisorBadge extends Component {
    constructor(props) {
        super(props);
        this.mode = props.mode;
        this.supervisors = props.supervisors;
        this.state = {
            showCount: false,
            target: null,
        };
    }

    handleButtonClick = (event) => {
        this.setState((prevState) => ({
            showCount: true,
            target: event.target,
        }));
        // Set a timeout to hide the tooltip after 3 seconds
        setTimeout(() => {
            this.setState({ showCount: false });
        }, 3000);

    };

    render() {
        return (
            <>
                {this.mode === 'compact' &&
                    (
                        <>
                            <Button
                                className={"SupervisorBadge"}
                                variant={this.supervisors.length > 0 ? "success":"danger"}
                                size="sm"
                                onClick={this.handleButtonClick}
                            >
                                {this.supervisors.length > 0 ? (
                                    <FontAwesomeIcon icon={faUserTie} style={{ padding: '0.2em' }} />
                                ) : (
                                    <FontAwesomeIcon icon={faUserXmark} style={{ padding: '0.2em' }} />
                                )}
                            </Button>
                            <Overlay target={this.state.target} show={this.state.showCount} placement="top">
                                {(props) => (
                                    <Tooltip id={"supervisor-overlay"} {...props}>
                                        {this.supervisors.length > 0 ? (
                                            <>
                                                <strong>{this.supervisors.length}</strong> Anzahl der verbundenen Supervisoren
                                            </>
                                        ) : 'Kein Supervisor verbunden'}
                                    </Tooltip>
                                )}
                            </Overlay>
                        </>
                    )}
                {this.mode === 'wide' &&
                    (
                        <>
                            {this.supervisors.map((supervisor, index) => {
                                return (
                                    <OverlayTrigger
                                    key={index} placement={"bottom"} overlay={
                                        <Tooltip id={"supervisor-tooltip"}>
                                            <span>
                                                {supervisor.email} <br /> {supervisor.phone}
                                            </span>

                                        </Tooltip>
                                    }>
                                        <Badge bg="dark" style={{ marginRight: '0.2em', marginBottom: '0.2em', cursor: 'pointer' }} key={index} onClick={() => { window.location = "/supervisor/"+supervisor._id; }}>
                                            <FontAwesomeIcon icon={faUserTie} /> {supervisor.lastName + ", " + supervisor.firstName}
                                        </Badge>
                                    </OverlayTrigger>
                                )
                            })}
                            {this.supervisors.length === 0 &&
                                <Badge bg="danger" style={{marginRight:'0.2em',marginBottom:'0.2em', cursor: 'pointer' }}>
                                    <FontAwesomeIcon icon={faUserXmark} /> Kein Supervisor verbunden
                                </Badge>

                            }
                        </>
                    )
                }
            </>
        );
    }
}

export default SupervisorBadge;
